import { z } from 'zod'

export const dashboardPluginSizeSchema = z.enum(['small', 'medium', 'large'])
export type DashboardPluginSize = z.infer<typeof dashboardPluginSizeSchema>
